import colunasPadrao from "./colunas_padrao";
import form_padrao from "./form_padrao";

import helpers from "@/common/utils/helpers";
let meses =  [];

export default {
    setInicio(dataInicio, numeroMes){
        meses = helpers.criarArrayMes(dataInicio, 60, !numeroMes)
        colunasPadrao.setInicio(dataInicio, numeroMes)
    },
    "st" : {
        titulo : "Serviço de terceiro",
        endpoint : "servico-terceiro",
        tipo : {
            label : "Tipo",
            options : helpers.getPGServicoTerceiro()
        },
        form : form_padrao,
        ...colunasPadrao
    },
    "mc" : {
        titulo : "Material de consumo",
        endpoint : "material-consumo",
        tipo : {
            label : "Tipo",
            options : helpers.getPGMaterialConsumo()
        },
        form : form_padrao,
        ...colunasPadrao
    },
    "vd" : {
        titulo : "Viagens e diárias",
        endpoint : "viagem-diaria",
        tipo : {label : "Tipo", options : helpers.getPGViagemDiaria()},
        form : form_padrao,
        previsao : [
            { key : "tipo",  label : "Tipo", 
                formatter : (value) => {
                    return helpers.getEnum(value).text;
                }
            },
            { key : "detalhamento",  label : "Detalhamento" },
            { key : "justificativa",  label : "Justificativa" },
            { key : "mes",  label : "Mês", 
                formatter : (a,b,c) => {
                    if(c.tipo == -1) return "";
                    return meses.find(el => el.value === c.mes).text;
                }
            },
            { key : "valorUnitario",  label : "Custo unitario",
                formatter : (a,b,c) => { 
                    if(c.tipo == -1) return "";
                    return helpers.formatarValor(c.valorUnitario) 
                }
            },
            { key : "quantidade",  label : "Qtd." },
            { key : "valorTotal",  label : "Valor total",
                formatter : (a,b,c) => {
                    if(c.id == -1) return helpers.formatarValor(c.valorUnitario);                    
                    return helpers.formatarValor(c.valorUnitario * c.quantidade);
                }
        },
            { key : "actions",  label : "Ações" },
        ],
        
    },
    "ou" : {
        titulo : "Outros recursos",
        endpoint : "outro-recurso",
        tipo : {
            label : "Tipo",
            options : helpers.getPGOutros()
        },
        form : form_padrao,
        ...colunasPadrao
    },
    "ct" : {
        titulo : "CITENEL",
        endpoint : "citenel",
        tipo : {
            label : "Tipo",
            options : helpers.getPGCitenel()
        },
        form : form_padrao,
        ...colunasPadrao
    },
    "auditoria" : {
        titulo : "Auditoria contábil",
        endpoint : "auditoria-contabil",
        tipo : {
            label : "Tipo",
            options : helpers.getPGAuditoria()
        },
        form : form_padrao,
        ...colunasPadrao
    }
}